<template>
  <div>
    <!-- 轮播 -->
    <div>
      <Delogin></Delogin>
    </div>
  </div>
</template>
<script>
  import { temp_categorys } from '@/api/temp';
  import { top_projects } from '@/api/project';
  import { config } from '@/api/config';
  import Delogin from './delogin/deindex.vue';
  import { columns } from './_index';
  import store from '@/store/index';
  import { mapGetters } from 'vuex';
  export default {
    name: 'Index',
    components: {
      Delogin,
    },
    data() {
      return {
        setting: {},
        banners: [],
        newsList: [],
        TempCategorys: [],
        projects: [],
        partner: [],
        newsIndex: 0,
        columns,
        store: store,
      };
    },
    computed: {
      ...mapGetters(['login']),
    },
    watch: {},
    mounted() {
      this.getConfig();
      this.getTempCategorys();
      this.getProject();
    },
    created() {},
    methods: {
      async getConfig() {
        this.setting = (await config()) || {};
      },
      async getTempCategorys() {
        this.TempCategorys =
          (await temp_categorys({ orderby: 'review desc,sort desc' })).data || [];
      },
      async getProject() {
        this.projects = (await top_projects()) || [];
      },
      openBlank(url, name) {
        url && window.open(url, name, '__blank');
      },
      handleGo(path) {
        this.$router.push(path);
      },
      gotoTemp(record) {
        this.$router.push(`/admin/contract_apply?project_id=${record.id}`);
      },
      gotoSign() {
        this.$store.commit('user/SET_LOGINSTATE', 'SMS_REGISTRY');
        this.$store.commit('user/SET_LOGINFLAG', true);
      },
    },
  };
</script>
<style lang="less" scoped>
  .title {
    position: relative;
    font-size: 32px;
    height: 45px;
    line-height: 45px;
    text-align: center;
  }
  .title:before {
    content: '';
    position: absolute;
    width: 1rem;
    height: 2px;
    top: 85%;
    left: 41%;
    background-color: #808080;
  }
  .title:after {
    content: '';
    position: absolute;
    width: 1rem;
    height: 2px;
    top: 85%;
    right: 41%;
    background-color: #808080;
  }
  .cusshadow {
    box-shadow: 0 5px 20px 0 rgba(19, 60, 154, 0.08), inset 0 2px 0 0 #fff;
  }
</style>
